// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TChatsBulkOperationsMoveToArchiveDesktopRequest,
  TChatsBulkOperationsMoveToArchiveDesktopModel,
  IMappers,
  TChatsBulkOperationsMoveToArchiveDesktopResponse,
  TChatsBulkOperationsMoveToArchiveDesktopResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../../../entities/schemas/ErrorResponseSchema';

export function createChatsBulkOperationsMoveToArchiveDesktopModel(
  parameters: TChatsBulkOperationsMoveToArchiveDesktopRequest,
): TChatsBulkOperationsMoveToArchiveDesktopModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'chats',
    pathApi: '/v1/chats/bulk-operations/move-to-archive-desktop/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IChatsBulkOperationsMoveToArchiveDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TChatsBulkOperationsMoveToArchiveDesktopRequest;
}

export async function fetchChatsBulkOperationsMoveToArchiveDesktop<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IChatsBulkOperationsMoveToArchiveDesktopOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TChatsBulkOperationsMoveToArchiveDesktopResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createChatsBulkOperationsMoveToArchiveDesktopModel(parameters),
    config,
  )) as FetchResponse<TChatsBulkOperationsMoveToArchiveDesktopResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TChatsBulkOperationsMoveToArchiveDesktopResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TChatsBulkOperationsMoveToArchiveDesktopResponse>;
}
